import Auth0ProviderInst from './Auth0Provider'
import { AuthHandler } from './AuthHandler'

export const defaultAuthHandler = new AuthHandler(Auth0ProviderInst)
